module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-event-item grid"
  }, [_vm._l((_vm.course.info_events), function(event, eventIdx) {
    return _c('script', {
      key: eventIdx,
      attrs: {
        "type": "application/ld+json"
      },
      domProps: {
        "textContent": _vm._s(JSON.stringify(event.content.schema))
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "info-event-item--row grid--row"
  }, [_c('div', {
    staticClass: "info-event-item--col grid--col"
  }, [_c('h2', {
    staticClass: "u-reset info-event-item--title",
    domProps: {
      "innerHTML": _vm._s(_vm.course.name)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-event-item--col grid--col"
  }, [(!_vm.numInfoEvents) ? _c('span', {
    staticClass: "info-event-item--empty",
    domProps: {
      "textContent": _vm._s(_vm.generalLabels.noEvents)
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.infoEventsTop), function(event, eventIdx) {
    return (_vm.numInfoEvents) ? _c('cmp-rich-button', {
      key: eventIdx,
      staticClass: "info-event-item--top-button",
      attrs: {
        "button-facet": "light",
        "theme": _vm.course.color,
        "plugin": event
      }
    }) : _vm._e()
  }), _vm._v(" "), (_vm.numInfoEvents > 1) ? _c('cmp-accordion', {
    attrs: {
      "facet": "info-event",
      "is-active": _vm.accordionState,
      "passive-mode": true
    },
    on: {
      "request-change": function($event) {
        _vm.updateState($event)
      }
    },
    scopedSlots: _vm._u([{
      key: "head",
      fn: function(props) {
        return [(!_vm.isHighlighted) ? _c('div', {
          staticClass: "info-event-item--accordion-head",
          class: _vm.accordionHeadClasses(props.isActive)
        }, [_c('span', {
          staticClass: "info-event-item--accordion-head-title"
        }, [(props.isActive) ? _c('span', {
          domProps: {
            "textContent": _vm._s(_vm.generalLabels.collapse)
          }
        }) : _c('span', {
          domProps: {
            "textContent": _vm._s(_vm.generalLabels.expand)
          }
        })]), _vm._v(" "), _c('cmp-icon', {
          staticClass: "info-event-item--accordion-head-icon",
          attrs: {
            "symbol": "chevron_down",
            "size": "x-small"
          }
        })], 1) : _vm._e()]
      }
    }, {
      key: "body",
      fn: function(props) {
        return [_c('div', {
          staticClass: "info-event-item--accordion-body"
        }, _vm._l((_vm.infoEventsInAccordion), function(event, eventIdx) {
          return _c('cmp-rich-button', {
            key: eventIdx,
            staticClass: "info-event-item--button",
            attrs: {
              "theme": _vm.course.color,
              "plugin": event
            }
          })
        }))]
      }
    }])
  }) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "info-event-item--col info-event-item--col__more-info grid--col"
  }, [_c('cmp-rich-button', {
    staticClass: "info-event-item--button",
    attrs: {
      "theme": _vm.course.color,
      "plugin": _vm.course.course_button
    }
  })], 1)])], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-506c4bb4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-506c4bb4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/info-event-item/index.vue
// module id = 544
// module chunks = 7